import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { VoiceCreationService } from "@/services/integrations/elevenlabs/VoiceCreationService";
import {
  CreateVoiceFromPreviewRequest,
  VoiceDesignRequest,
  VoicePreviewResponse,
} from "@/types/voice/voice-creation";

const voiceCreationService = VoiceCreationService.getInstance();

export const useVoiceDesignPreview = () => {
  return useMutation<VoicePreviewResponse, Error, VoiceDesignRequest>({
    mutationFn: (payload) => voiceCreationService.designVoice(payload),
    onError: (error) => {
      console.error("Voice design preview failed:", error);
      toast.error("Failed to generate voice previews.");
    },
  });
};

export const useCreateVoiceFromPreview = () => {
  return useMutation({
    mutationFn: (payload: CreateVoiceFromPreviewRequest) =>
      voiceCreationService.createVoiceFromPreview(payload),
    onError: (error: Error) => {
      console.error("Create voice from preview failed:", error);
      toast.error("Failed to create voice from preview.");
    },
  });
};
